import { createAsyncThunk } from '@reduxjs/toolkit';

import { OrdersHttpGetService } from 'Feature/Common/Common/Services/OrderHttpService';
import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

export const getPodUserInfo = createAsyncThunk('Order/getPodUserInfo', async () => {
  return await OrdersHttpGetService({
    url: `${_apiPathManagerConfig?.Orders.Order.getPodUserInfo}`,

    // onResult: (res: AxiosResponse<any, any>): any => {
    //   return res;
    // }
  });
});
